export default "__VITE_ASSET__C_d6tbgj__"